import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user')),
    bots: [],
    companyStat: null,
    freeMessages: 0
  },
  getters: {
    isAuthenticated: state => !!state.user,
    userName(state){
      if(state.user != null){
        let fullName = ''
        if(state.user.first_name !== undefined)
          fullName = state.user.first_name.toUpperCase()
        if(state.user.last_name !== undefined){
          fullName += ' '
          fullName += state.user.last_name.toUpperCase()
        }
        return fullName
      } else {
        return 'John Doe'
      }
    },
    userId(state){
      if(state.user != null){
        return state.user.id
      } else {
        return 'None'
      }
    }
  },
  mutations: {
    setUser(state, user){
      state.user = user
    },
    setCompanyStat(state, companyStat){
      state.companyStat = companyStat
    },
    setBots(state, bots){
      state.bots = bots
    },
    setFreeMessages(state, freeMessages){
      state.freeMessages = freeMessages
    }
  },
  actions: {
    login (context, user) {
      localStorage.setItem('user', JSON.stringify(user));
      context.commit('setUser', user)
    },
    logout (context) {
      localStorage.removeItem('user');
      localStorage.removeItem('BCuser');
      context.commit('setUser', null);
    },
  },
  modules: {
  }
})
